import React from 'react'
import { useIsAuthenticated } from '@core/Utils/hooks/useIsAuthenticated'

export const RequireAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const auth = useIsAuthenticated()
  if (!auth) return null

  return children
}
